/**
 * Logomark com tratamento visual de ícone de aplicativo (squircle, plate escuro, profundidade).
 */
export default function LogoAppIcon({ src, alt, className = "" }) {
  const decorative = alt === "";

  return (
    <span
      className={[
        "relative isolate inline-flex shrink-0 overflow-hidden rounded-[28%]",
        "bg-gradient-to-br from-night-800 via-night-900 to-black",
        "shadow-[0_10px_32px_-8px_rgba(0,0,0,0.65),0_4px_14px_-4px_rgba(111,60,255,0.22),inset_0_1px_0_rgba(255,255,255,0.08)]",
        "ring-1 ring-inset ring-white/10",
        "transition duration-300 ease-out",
        "group-hover:scale-[1.05] group-hover:shadow-[0_14px_40px_-8px_rgba(0,0,0,0.7),0_6px_22px_-4px_rgba(111,60,255,0.35),inset_0_1px_0_rgba(255,255,255,0.12)]",
        "group-active:scale-[0.97]",
        className,
      ].join(" ")}
    >
      <span
        className="pointer-events-none absolute inset-0 rounded-[inherit] bg-gradient-to-b from-white/[0.12] via-transparent to-transparent opacity-80"
        aria-hidden
      />
      <span
        className="pointer-events-none absolute inset-x-0 bottom-0 h-[40%] rounded-b-[inherit] bg-gradient-to-t from-black/55 to-transparent"
        aria-hidden
      />
      <img
        src={src}
        alt={decorative ? "" : alt}
        {...(decorative ? { "aria-hidden": true } : {})}
        draggable={false}
        className="relative z-10 h-full w-full select-none object-contain p-[2%] drop-shadow-[0_2px_12px_rgba(0,0,0,0.55)]"
      />
    </span>
  );
}
